// extracted by mini-css-extract-plugin
module.exports = {"main":"AvailabilityResult_main__YSR5E","filters":"AvailabilityResult_filters__2ZvAo","hotels":"AvailabilityResult_hotels__2Ltbf","hotel":"AvailabilityResult_hotel__2K8bV"};